import { normalizeBase } from '../app/paths.js';

/**
 * Typed config, resolved once at the composition root.
 *
 * WHY: env is stringly-typed and untrusted; we parse it into a typed shape at
 * the edge (same discipline as domain input). v1 has no live flags at all —
 * the People Engine is a mock-always simulation (`simulation` is hard `true`
 * until a first live adapter exists), so unlike the Idea Engine there is
 * nothing to toggle yet. Flags join here when live drafting/persistence land
 * (backlog N1/N2).
 */
export interface AppConfig {
  readonly locale: string;
  /** Whether the app is running against mocks (drives the SIMULATION badge). */
  readonly simulation: boolean;
  /** Deploy base path (normalized, e.g. '' for root or '/hr' for subpath deploys). */
  readonly basePath: string;
}

/** The untyped env bag as Vite exposes it (`import.meta.env`). */
export type RawEnv = Readonly<Record<string, string | boolean | undefined>>;

function readString(env: RawEnv, key: string): string | undefined {
  const value = env[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

export function resolveConfig(env: RawEnv): AppConfig {
  return {
    locale: readString(env, 'LOCALE') ?? 'en-US',
    simulation: true,
    basePath: normalizeBase(readString(env, 'BASE_URL')),
  };
}
